import balanceText from 'balance-text';
import CookiesEuBanner from 'cookies-eu-banner';
import URI from 'urijs';


$('.claim-slick').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: true,
  arrows: false,
  speed: 750,
  centerMode: false,
  adaptiveHeight: true,
  focusOnSelect: false,
  autoplay: true,
  autoplaySpeed: $('.claim-slick').data('autoplay-speed'),
});

$('.card-slick').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  dots: false,
  arrows: true,
  speed: 750,
  centerMode: false,
  adaptiveHeight: false,
  focusOnSelect: false,
  autoplay: false,
  responsive: [
    {
      breakpoint: 1600,
      settings: {
        slidesToShow: 3,
      }
    },
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 2,
      }
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        swipeToSlide: true,
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        swipeToSlide: true,
      }
    }
  ],
  prevArrow: '<div class="arrow-left"><span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>' +
             '<span class="sr-only">Vorherige</span></div>',
  nextArrow: '<div class="arrow-right"><span class="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>' +
             '<span class="sr-only">Nächste</span>'
});

$('[data-box-href]').on('click', function() {
  window.location.href = $(this).data('box-href');
});

balanceText('.balance-text');

$('.images-slick').slick({
  infinite: true,
  slidesToShow: 3,
  arrows: true,
  dots: false,
  cssEase: 'ease-in-out',
  responsive: [
    {
      breakpoint: 1600,
      settings: {
        slidesToShow: 3,
      }
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        swipeToSlide: true,
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        swipeToSlide: true,
      }
    }
  ],
  prevArrow: '<div class="arrow-left"><span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>' +
             '<span class="sr-only">Vorherige</span></div>',
  nextArrow: '<div class="arrow-right"><span class="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>' +
             '<span class="sr-only">Nächste</span>'
});

try {
  var photogalleryOptions = {shareButtons: localizedShareButtons};
} catch (ReferenceError) {
  var photogalleryOptions = {};
}

$.extend( photogalleryOptions, {
  itemFilter: function() {
    return $(this).parents('.slick-cloned').length === 0;
  },
  captionSelector: ':parent .caption'
});

$('.images-stream').photogallery(photogalleryOptions);
var banner = new CookiesEuBanner(function(){});

$(document).ready(function() {
  if ($('.template-homepage').length) {
    var logo = $('.logo-svg');
    var brandName = $('.navbar-brand');
    $(window).scroll( function(){
      var bottomLogo = logo.offset().top + logo.outerHeight();
      var topOfWindow = $(window).scrollTop();
      /* If the object is not visible in the window, fade in */
      var top = (1 - (topOfWindow / bottomLogo)) * -200;
      if (top > 0) {
        top = 0;
      }

      var left = (1 - (topOfWindow / bottomLogo)) * -163;
      if (left > -35) {
        left = -35;
      }

      brandName.css({
        'opacity': topOfWindow / bottomLogo,
        'margin-left': left + 'px',
      });
      // brandName.find('a').css({
      //   'top': top + '%',
      // })
    });

  }

  if ($('#ContentPageModal').length) {
    $('body').on('click', '.contains-modal-toggle a', function (e) {
      e.preventDefault();
      var dataTarget = $('#ContentPageModal');
      var modal = $(dataTarget);
      var el = $(this);
      var link = el.data('box-link');
      var boxbutton = el.data('box-button');

      $.get(el.attr('href'), function (data) {
        var modalPage = $(data);
        modal.find('.modal-title').text(modalPage.find('h1').text());
        modal.find('.modal-body').html(
          modalPage.find('.content-body-content, .content-body-intro, .images-stream').map(function () {
            var el = $(this);
            if (el.is('.content-body-intro')) {
              return '<div class="content-intro">' + $(this).html() + '</div>';
            }
            return $(this).html();
          }).get().join('<br>')
        );

        var label = modal.find('.modal-header button').attr('aria-label');
        var btn = $('<a class="btn btn-default" data-dismiss="modal">' + label + '</a>');
        if (link) {
          btn.attr('href', link)
          btn.removeAttr('data-dismiss')
        }

        if (boxbutton) {
          btn.removeClass('btn-default');
          btn.addClass('btn-primary');
          btn.addClass('btn-lg');
          btn.text(boxbutton);
        }

        modal.find('.modal-footer').html(btn);

        modal.modal('toggle');
      });
    });
  }

  var hasRedirect = $('.amate-redirect').length > 0;
  if (!hasRedirect) {
    var amateRegex = /(amate|mailto)/;
    $('.container-fluid a[href*="//"]').each(function() {
      var target = new URI($(this).attr('href'));
      target.normalize();
      if (target.is('absolute')) {
        var hostUrl = target.host().toString();
        var isAmate = amateRegex.test(hostUrl);
        // This is an external link
        if (isAmate !== true) {
          $(this).attr({
            'target': '_blank',
            'rel': 'noopener'
          });
        }
      }
    });
  }

  var addForm = $('#add_to_basket_form');
  if (addForm.length) {
    var childID; // = 5; // addForm.find('input[name="child_id"]').val();
    var quantity = 1;
    var choices = jQuery.parseJSON(addForm.find('input[name="choices_dict"]').val());

    var subscriptionWasSelected = addForm.find('input[name="is_recurring"]:checked').val() == 'true';
    var subscriptionBoxAccept = $('#subscriptionBoxAccept');
    var collapseSelfPickHint = $('#collapseSelfPickHint');

    var recurringToggled;
    var acceptToggled;
    var selfPickToggled = addForm.find('input[name="is_self_pickup"]').is(':checked');

    if (subscriptionBoxAccept.length) {
      acceptToggled = $('#subscriptionBox');
      recurringToggled = $('#subscriptionBoxHint');
    } else {
      recurringToggled = $('#subscriptionBox');
      acceptToggled = $();
    }

    acceptToggled.collapse({
      toggle: subscriptionWasSelected
    });
    recurringToggled.collapse({
      toggle: subscriptionWasSelected
    });
    collapseSelfPickHint.collapse({
      toggle: selfPickToggled
    })

    if (subscriptionWasSelected) {
      subscriptionBoxAccept.parent().hide();
    } else {
      subscriptionBoxAccept.on('change', function() {
        acceptToggled.collapse($(this).is(':checked') ? 'show': 'hide');
      });
    }

    $(addForm).on('change', 'input[name="is_recurring"]', function() {
      recurringToggled.collapse(
        ($(this).val() == 'true') ? 'show': 'hide');
    });

    $('#input-addon-recurring-start').on('click', function() {
      $(this).next('input').focus();
    });

    $(addForm).on('change', 'input[name="is_self_pickup"]', function () {
      collapseSelfPickHint.collapse($(this).is(':checked') ? 'show' : 'hide');
    });

    $('input[name="recurring_start"]').datepicker().on('changeDate', function() {
      var self = $(this);
      self.one('mouseout', function() {
        self.datepicker('hide');
      });
    });

    $('.contains-modal-toggle').on('click', 'a', function (e) {
      e.preventDefault();
      var dataTarget = $('#ShippingModal');
      var modal = $(dataTarget);
      $.get($(this).attr('href'), function (data) {
        var modalPage = $(data);
        modal.find('.modal-title').text(modalPage.find('h1').text());
        modal.find('.modal-body').html(
          modalPage.find('.content-body-content, .content-body-intro').map(function () {
            var el = $(this);
            if (el.is('.content-body-intro')) {
              return '<div class="content-intro">' + $(this).html() + '</div>';
            }
            return $(this).html();
          }).get().join('<br>')
        );
        modal.modal('toggle');
      });
    });

    $('.contains-modal-toggle--with-images').on('click', 'a', function (e) {
      e.preventDefault();
      var dataTarget = $('#ShippingModal');
      var modal = $(dataTarget);
      $.get($(this).attr('href'), function (data) {
        var modalPage = $(data);
        modal.find('.modal-title').text(modalPage.find('h1').text());
        modal.find('.modal-body').html(
          modalPage.find('.content-body-content, .content-body-intro, .images-stream').map(function () {
            var el = $(this);
            if (el.is('.content-body-intro')) {
              return '<div class="content-intro">' + $(this).html() + '</div>';
            }
            return $(this).html();
          }).get().join('<br>')
        );
        modal.modal('toggle');
      });
    });

    $('[data-toggle="tooltip"]').tooltip();

    function removeOutlines(e){
      // add the class to the body that removes outlines
      $(this).parent().addClass('no-outline');
      // remove this event handler because it's no longer needed
      addForm.off('click', 'input.variante-radio', removeOutlines);
    }
    addForm.on('click', removeOutlines);

    addForm.on('click', '#input-addon-quantity-minus', function() {
      var qty = parseInt(addForm.find('input[name="quantity"]').val(), 10);
      if (qty > 1) {
        addForm.find('input[name="quantity"]').val(qty - 1).trigger('change');
      }
    });

    addForm.on('click', '#input-addon-quantity-plus', function() {
      var qty = parseInt(addForm.find('input[name="quantity"]').val(), 10);
      addForm.find('input[name="quantity"]').val(qty + 1).trigger('change');
    });

    addForm.on('change', ['input[name="child_id_0"]', 'input[name="child_id_1"]', 'input[name="quantity"]'], function () {
      var subChildID0 = parseInt($('#add_to_basket_form input[name="child_id_0"]:checked').val(), 10);
      var subChildID1 = parseInt($('#add_to_basket_form input[name="child_id_1"]:checked').val(), 10);
      var newQuantity = parseInt($('#add_to_basket_form input[name="quantity"]').val(), 10);
      var labelID0 = $('#add_to_basket_form input[name="child_id_0"]:checked').next('label').text();
      var labelID1 = $('#add_to_basket_form input[name="child_id_1"]:checked').next('label').text();

      var newChildID = childID;

      $.each(choices, function(key, value) {
        if (jQuery.inArray(subChildID0, value) !== -1 &&
            jQuery.inArray(subChildID1, value) !== -1) {
          newChildID = key;
        }
      });

      if (childID !== newChildID || quantity !== newQuantity) {
        var newProductURI = new URI();
        newProductURI.search({
          'child_id': newChildID,
          'quantity': newQuantity
        });
        // $('.oscar-price-box').html('<span class="oscar-price-loading">' +
        //   '<i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>' +
        //   '<span class="sr-only">Loading...</span></span>');

        $('.oscar-price-box').load(newProductURI + ' .oscar-price-box', function() {
          childID = newChildID;
          quantity = newQuantity;
          // $('.oscar-price-box').css('opacity', '0');
          // $('.oscar-price-box').animate({'opacity': '1'}, 200);
          $(function () {
            $('[data-toggle="tooltip"]').tooltip();
          });
          gtag('event', 'view_item', {
            'items': [
              {
                'id': childID,
                'name': $('.product_page h1').text(),
                'list_name': 'Shop Detailpage',
                'category': 'Kaffee', // @TODO dynamic !!
                'variant': labelID0.trim() + ' - ' + labelID1.trim(),
                'list_position': subChildID1,
                'quantity': quantity,
                'price': $('.price-value.price_color').data('price')
              }
            ]
          });
        });
      }
    });
  }

  var ShippingTooltip = $('.shipping-tooltip');
  if (ShippingTooltip.length) {
    var ShippingTooltipText = ShippingTooltip.find('.shipping-tooltip-text').html();
    $('.shipping-tooltip-toggle').tooltip({
      title: ShippingTooltipText,
      html: true
    });
  }
});

$(document).ready(function() {
  var modal = $('#LineAttributeChangeModal').modal({
    show: false,
    backdrop: 'static'
  });
  $('#content_inner').on('click', '#basket_formset a[data-behaviours~="change_attribute"]', function(event) {
    var rowID = $(this).data('id');
    var redirectTarget = $(this).data('target');
    event.preventDefault();

    modal.modal('toggle');
    modal.one('click', '.modal__btn--apply', function() {
      modal.on('hide.bs.modal', function(e){
        e.preventDefault();
        e.stopImmediatePropagation();
        return false;
      });
      $('#basket_formset a[data-behaviours~="remove"][data-id="' + rowID + '"]').trigger('click');
      setTimeout(function() {
        window.location.href = redirectTarget;
      }, 200);
    });
  });

  var CheckoutError = $('#CheckoutError');
  if (CheckoutError.length) {
    CheckoutError.modal('toggle');
  }

  var ConfirmationInfo = $('#ConfirmationInfo');
  if (ConfirmationInfo.length) {
    ConfirmationInfo.modal('toggle');
  }


});

$(document).ready(function() {
  var NewShippingAddress = $('#new_shipping_address');
  var ShippingAddressBoxes = $('.ship-address-box');
  var messageSeen = false;

  function shippingChanged(old, current) {
    if (old == current) return false;
    return (old == 'DE') || (current == 'DE');
  }

  if (NewShippingAddress.length) {
    var countryField = NewShippingAddress.find('#id_country');
    var initalCountry = countryField.val();

    countryField.on('change', function() {
      var selectedCountry = $( this ).val();
      if (!messageSeen && shippingChanged(initalCountry, selectedCountry)) {
        $('#ShippingNoticeModal').modal('toggle');
        initalCountry = selectedCountry;
      }
    });
  }

  if (ShippingAddressBoxes.length) {
    ShippingAddressBoxes.on('click', '.ship-address', function(event) {
      var initalCountry = $(this).parents('.ship-address-box').data('country');
      var selectedCountry = $(this).parents('.ship-address-box').data('address-country');
      var self = this;
      if (!messageSeen && shippingChanged(initalCountry, selectedCountry)) {
        event.preventDefault();
        $('#ShippingNoticeModal').one('click', '.btn-success', function (e) {
          messageSeen = true;
          $(self).trigger('click');
        });
        $('#ShippingNoticeModal').modal('toggle');
        return false;
      }
      return true;
    });
  }

  $('#ShippingNoticeModal').on('hidden.bs.modal', function (e) {
    messageSeen = true;
  });

});

$(document).ready(function () {
var CherryRedeemForm = $('#CherryRedeemForm');

if (CherryRedeemForm.length) {
  var cherries = parseInt(CherryRedeemForm.data('coffeecherries'), 10);
  var disabledLabel = CherryRedeemForm.data('disabled-label');
  var CoffeecherryNewSum = CherryRedeemForm.find('#CoffeecherryNewSum');
  var currentCherries = cherries;

  $('.coffeecherry-voucher__redeem-now').click(function (e) {
    var el = $(this);
    var modal = $('#CoffeePointsSpendModal');

    e.preventDefault();

    modal.find('.modal-dialog').load(el.attr('href') + ' #CoffeePointsSpendModalContent', function () {
      var form = $('#CoffeePointsSpendForm');
      initAvailabilityCheck(form);

      modal.on('hidden.bs.modal', function () {
        unSetAvailabilityCheck(form);
      });
    });
    modal.modal('toggle');
  });

  function initAvailabilityCheck(form) {
    var availabilites = $.parseJSON(form.find('#id_availability').val());
    form.on(
      'change', [
        '.account-subscription__parent select',
        '.account-subscription__milling select',
        '.account-subscription__weight select'
      ],
      function () {
        checkAvailability(form, availabilites);
      }
    );
  }

  function unSetAvailabilityCheck(form) {
    form.off(
      'change', [
        '.account-subscription__parent select',
        '.account-subscription__milling select',
        '.account-subscription__weight select'
      ]);
  }

  function getProductLabel(row) {
    var lineParent = row.find('.account-subscription__parent select').val();
    var lineMilling = row.find('.account-subscription__milling select').val();
    var lineWeight = row.find('.account-subscription__weight select').val();
    return lineParent + '_' + lineMilling + '_' + lineWeight;
  }

  function checkAvailability(form, availabilites) {
    var row = form.find('.account-subscription__product-row');
    var label = getProductLabel(row);
    var rowAvailable = availabilites[label].availability;
    row.toggleClass('account-subscription__product-row--notavailable', !rowAvailable);
    row.find('.account-subscription__notavailable').toggleClass('account-subscription__notavailable--shown', !rowAvailable);

    if (!rowAvailable) {
      form.find('.modal__btn--apply').attr('disabled', 'disabled');
    } else {
      form.find('.modal__btn--apply').removeAttr('disabled');
    }
  }

  function disableTooExpensive(cherries) {
    CherryRedeemForm.find('[name="voucher"]:not(:checked)').each(function () {
      var field = $(this);
      var parent = field.parent();
      var fieldPrice = parseInt(field.data('price'), 10);

      if (fieldPrice > cherries) {
        field.attr('disabled', 'disabled');
        //parent.attr('title', disabledLabel);
        parent.attr('data-original-title', disabledLabel);
        parent.addClass('not-allowed');
      }
    });
  }

  function resetDisabled() {
    CherryRedeemForm.find('[name="voucher"]').each(function () {
      var field = $(this);
      var parent = field.parent();
      field.removeAttr('disabled');
      //parent.attr('title', '');
      parent.attr('data-original-title', '');
      parent.removeClass('not-allowed');
    });
  }

  function countChecked() {
    var checkedPrices = CherryRedeemForm.find('[name="voucher"]:checked').map(function () {
      var field = $(this);
      return parseInt(field.data('price'), 10);
    }).get();
    return checkedPrices.reduce(function (total, price) {
      return total + price;
    }, 0);
  }

  function update() {
    currentCherries = cherries - countChecked();
    CoffeecherryNewSum.text(currentCherries);
    resetDisabled();
    disableTooExpensive(currentCherries);

  }

  CherryRedeemForm.tooltip(
    {
      trigger: 'hover',
      selector: '.coffeecherry-item',
      placement: 'left',
      container: 'body'
    });

  CherryRedeemForm.on('change', '[name="voucher"]', update);

  update();
}

var AccountSubscription = $('.account-subscription');

if (AccountSubscription.length) {
  var SubscriptionCancelModal = $('#SubscriptionCancelModal');
  var subscriptionCancelSeen = false;
  var disabledLabel = AccountSubscription.data('disabled-label');

  // cancel pop-up
  AccountSubscription.on('submit', '.account-subscription-item__state-cancel', function (e) {
    var self = this;

    if (!subscriptionCancelSeen) {
      e.preventDefault();
      SubscriptionCancelModal.one('click', '.modal__btn--apply', function (e) {
        subscriptionCancelSeen = true;
        $(self).find('[type="submit"]').trigger('click');
      });
      SubscriptionCancelModal.modal('toggle');
      return false;
    }
    return true;
  });


  AccountSubscription.tooltip(
    {
      trigger: 'hover',
      selector: '.account-subscription__delete-group',
      placement: 'top',
      container: 'body'
    });

  var SubscriptionPauseModal = $('#SubscriptionPauseModal');
  var subscriptionPauseSeen = false;

  // pause pop-up
  AccountSubscription.on('submit', '.account-subscription-item__state-change--pause', function (e) {
    var self = this;

    if (!subscriptionPauseSeen) {
      e.preventDefault();
      SubscriptionPauseModal.one('click', '.modal__btn--apply', function (e) {
        subscriptionPauseSeen = true;
        $(self).find('[type="submit"]').trigger('click');
      });
      SubscriptionPauseModal.modal('toggle');
      return false;
    }
    return true;
  });

  // account-subscription__delete change text
  $('.account-subscription__delete').on('change', 'input', function() {
    var input = $(this);
    var label = input.is(':checked') ? input.parent().data('label-active') : input.parent().data('label-inactive');

    input.next('span').text(label);
    input.parents('.row').eq(0).toggleClass('account-subscription__product-row--deleted', input.is(':checked'));
    input.parents('.row').eq(0).find('.account-subscription__deleted').toggleClass(
      'account-subscription__deleted--shown', input.is(':checked'));
  });

  function getRowLabel(row) {
    var lineParent = row.find('.account-subscription__parent select').val();
    var lineMilling = row.find('.account-subscription__milling select').val();
    var lineWeight = row.find('.account-subscription__weight select').val();
    return lineParent + '_' + lineMilling + '_' + lineWeight;
  }

  function calcTotal(rows, prices) {
    var priceList = prices || window.PigeonProducts;
    var linePrices = rows.map(function () {
      var row = $(this);
      var lineQuantity = row.find('.account-subscription__quantity input').val();
      var lineDeleted = row.find('.account-subscription__delete input').is(':checked');
      var priceLabel = getRowLabel(row);

      if (lineDeleted) {
        return 0;
      }

      return priceList[priceLabel].price * parseInt(lineQuantity, 10);
    }).get();

    return linePrices.reduce(function (total, price) {
      return total + price;
    }, 0);
  }

  function calcWeights(rows, prices) {
    var priceList = prices || window.PigeonProducts;

    var lineWeights = rows.map(function () {
      var row = $(this);
      var lineQuantity = row.find('.account-subscription__quantity input').val();
      var lineDeleted = row.find('.account-subscription__delete input').is(':checked');
      var priceLabel = getRowLabel(row);

      if (lineDeleted) {
        return 0;
      }

      return priceList[priceLabel].weight * parseInt(lineQuantity, 10);
    }).get();

    return lineWeights.reduce(function (total, weight) {
      return total + weight;
    }, 0);
  }

  function checkAvailability(rows, prices) {
    var priceList = prices || window.PigeonProducts;
    var lineAvailability = rows.map(function () {
      var row = $(this);
      var priceLabel = getRowLabel(row);
      var rowAvailable = priceList[priceLabel].availability;
      row.toggleClass('account-subscription__product-row--notavailable', !rowAvailable);
      row.find('.account-subscription__notavailable').toggleClass('account-subscription__notavailable--shown', !rowAvailable);
      return rowAvailable;
    }).get();

    return lineAvailability.reduce(function (total, current) {
      return total && current;
    }, true);
  }


  function disableEnableDeletes(rows) {
    rows.each(function () {
      let button = $(this).find('.account-subscription__delete');
      button.toggleClass('disabled', false);
      button.parent().attr('data-original-title', '');
      button.parent().removeClass('not-allowed');
    });

    var deletedRows = rows.filter('.account-subscription__product-row--deleted').length;

    if (deletedRows >= rows.length - 1) {
      rows.filter(':not(.account-subscription__product-row--deleted)').each(function () {
        let button = $(this).find('.account-subscription__delete');
        button.toggleClass('disabled', true);
        button.parent().attr('data-original-title', disabledLabel);
        button.parent().addClass('not-allowed');
      });
    }
  }

  var formClass = '.account-subscription__change';
  function refreshSubValues(event) {
    var rows = $(this).find('.account-subscription__product-row');

    var newTotal = calcTotal(rows).toLocaleString($('html').attr('lang'));
    var total = $(this).find('.account-subscription__new-total');
    total.text(newTotal);

    var available = checkAvailability(rows);
    $(this).find('[name="has_unavailable"]').val(!available);

    disableEnableDeletes(rows);

    var shippingList = window.PigeonShippings;
    var shippingTotal = $(this).find('.account-subscription-shipping-total__value');
    var shippingID = parseInt(shippingTotal.data('shipping-id'));
    var totalWeight = calcWeights(rows);
    var newShippingTotal = parseFloat(shippingTotal.text());
    $.each(shippingList[shippingID].slice().reverse(), function (index, band) {
      if (totalWeight <= parseFloat(band.upper_limit)) {
        newShippingTotal = band.charge;
      }
    });
    shippingTotal.text(newShippingTotal.toLocaleString($('html').attr('lang')));
  }

  $(formClass).on(
    'change', [
      '.account-subscription__product-row input', '.account-subscription__product-row select'
    ],
    refreshSubValues
  );
  var SubscriptionNotAvailableModal = $('#SubscriptionNotAvailableModal');
  var subscriptionNotAvailableSeen = false;
  // NotAvailable pop-up
  AccountSubscription.on('submit', formClass, function (e) {
    var self = this;
    var hasUnavailable = $(this).find('[name="has_unavailable"]').val() == 'true';

    if (!subscriptionNotAvailableSeen && hasUnavailable) {
      e.preventDefault();
      SubscriptionNotAvailableModal.one('click', '.modal__btn--apply', function (e) {
        subscriptionNotAvailableSeen = true;
        $(self).find('[type="submit"]').trigger('click');
      });
      SubscriptionNotAvailableModal.modal('toggle');
      return false;
    }
    return true;
  });

  // no this refreshSubValues();
}
});


$(document).ready(function () {
  var RegisterForm = $('.register_form');

  if (RegisterForm.length) {
    $('.contains-modal-toggle').on('click', 'a', function (e) {
      e.preventDefault();
      var dataTarget = $('#RegisterInfoModal');
      var modal = $(dataTarget);
      $.get($(this).attr('href'), function (data) {
        var modalPage = $(data);
        modal.find('.modal-title').text(modalPage.find('h1').text());
        modal.find('.modal-body').html(
          modalPage.find('.content-body-content, .content-body-intro').map(function () {
            var el = $(this);
            if (el.is('.content-body-intro')) {
              return '<div class="content-intro">' + $(this).html() + '</div>';
            }
            return $(this).html();
          }).get().join('<br>')
        );
        modal.modal('toggle');
      });
    });
  }
});

$(document).ready(function () {
  var PaymentDetailAddresses = $('#PaymentDetailAddresses');
  var PaymentDetailForm = $('#PaymentDetailForm');
  var storage = null;

  if (PaymentDetailForm.length) {
    var paymethod = PaymentDetailForm.find('input[name="paymethod"]');

    function restoreAddressForms() {
      if (storage) {
        PaymentDetailAddresses.html(storage);
      }
    }

    function saveAddressForms() {
      storage = PaymentDetailAddresses.html();
    }

    function removeAddressForms() {
      saveAddressForms()
      PaymentDetailAddresses.html(null);
    }

    paymethod.on('change', function (event) {
      if ($(this).val() == 'self-pickup') {
        removeAddressForms();
      } else {
        restoreAddressForms();
      }
    });

    if (PaymentDetailForm.find('input[name="paymethod"]:checked').val() == 'self-pickup') {
      removeAddressForms();
    }
  }
});

$(document).ready(function () {
  var AddUpsellForms = $('.add_upsell_to_basket');
  if (AddUpsellForms.length) {
    AddUpsellForms.on('change', 'input', function (params) {
      var input = $(this);
      var parent_form = input.parents('.add_upsell_to_basket');

      $('.add_upsell_to_basket').not(parent_form).find('input[type="radio"]').prop('checked', false);
    });
  }
});
